"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var mainHeaderWithBackLinkStyles_1 = require("./mainHeaderWithBackLinkStyles");
var material_ui_image_1 = require("material-ui-image");
var logo_png_1 = require("../../../assets/images/logo.png");
var core_1 = require("@material-ui/core");
var BleedContainer_1 = require("../Misc/BleedContainer");
var clsx_1 = require("clsx");
var Translation_1 = require("../Translation/Translation");
var NavigationContainer_1 = require("../Navigation/NavigationContainer");
var MainHeaderWithBackLink = function (_a) {
    var _b;
    var titleTranslation = _a.titleTranslation, withBackLink = _a.withBackLink, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, stickyHeader = _a.stickyHeader;
    var _d = core_1.useTheme().checkoutLite.common, showHeader = _d.showHeader, showLogo = _d.showLogo;
    if (!showHeader) {
        return null;
    }
    var style = mainHeaderWithBackLinkStyles_1.default();
    return (<BleedContainer_1.default data-test="container:mainHeader" className={clsx_1.default((_b = {}, _b[style.stickyHeader] = stickyHeader, _b))}>
      {showLogo && (<material_ui_image_1.default key="Market Logo" src={logo_png_1.default} data-test="image:mainHeader:logo" alt="Market Logo" color="transparent" imageStyle={{
        height: '44px',
        width: '165px',
        left: 'inherit',
    }} style={{
        height: '60px',
        width: '100%',
        paddingTop: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }}/>)}
      <core_1.Box className={clsx_1.default(style.step, theme === 'default' ? style.default : style.simple)}>
        {withBackLink && <NavigationContainer_1.default />}
        <core_1.Typography className={style.headerTitle} component="h1" variant="h4" data-test="text:mainHeader:currentJourney">
          <Translation_1.default id={titleTranslation}/>
        </core_1.Typography>
      </core_1.Box>
    </BleedContainer_1.default>);
};
exports.default = MainHeaderWithBackLink;
